import React, { useState } from "react";
import { Dropdown } from "antd";
import { DashMetricsPickerSkeleton } from "./DashCardSkeletons";
import { REVENUE_METRIC_OPTIONS, getMetricMenuHint } from "./revenueMetricsConfig";

export default function DashRevenueMetricsPickerCard({
  selectedIds = [],
  onChange,
  loading = false,
  revenueKpis,
}) {
  const [open, setOpen] = useState(false);
  const available = REVENUE_METRIC_OPTIONS.filter((o) => !selectedIds.includes(o.id));

  const addMetric = (id) => {
    if (!id || selectedIds.includes(id)) return;
    onChange([...selectedIds, id]);
    setOpen(false);
  };

  const menu = (
    <div className="metrics-picker-menu" onClick={(e) => e.stopPropagation()}>
      <div className="metrics-picker-menu__head">SELECT METRIC</div>
      <div className="metrics-picker-menu__list">
        {available.length === 0 ? (
          <div className="metrics-picker-menu__empty">All metrics added</div>
        ) : (
          available.map((opt) => {
            const hint = getMetricMenuHint(opt.id, revenueKpis);
            return (
              <button
                key={opt.id}
                type="button"
                className="metrics-picker-menu__item"
                onClick={() => addMetric(opt.id)}
              >
                <span className="metrics-picker-menu__item-name">{opt.label.toUpperCase()}</span>
                {hint ? <span className="metrics-picker-menu__item-hint">{hint}</span> : null}
              </button>
            );
          })
        )}
      </div>
    </div>
  );

  return (
    <div className="h-100 d-flex align-items-center">
      <div className="d-flex align-items-center">
        <div className="acr-card__body p-0 d-flex flex-row h-100 align-items-center">
          <Dropdown
            open={open}
            onOpenChange={setOpen}
            dropdownRender={() => menu}
            trigger={["click"]}
            placement="bottomLeft"
            disabled={loading || available.length === 0}
            overlayClassName="metrics-picker-dropdown"
            getPopupContainer={(node) => node.parentElement || document.body}
          >
            <span className="d-inline-block">
              <button
                type="button"
                className="btn btn-outline btn-outline-dashed btn-icon btn-cus-outline metrics-picker__add"
                disabled={loading || available.length === 0}
                title={loading || available.length === 0 ? "No more metrics to add" : "Add metric"}
              >
                {loading ? <DashMetricsPickerSkeleton /> : <i className="ki-outline ki-plus fs-1" />}
              </button>
            </span>
          </Dropdown>

          {available.length === 0 && (
            <div className="ms-3 flex-grow-1">
              <div className="acr-picker__no-more-metrics text-muted" style={{ fontSize: "0.98rem" }}>
                All available metrics have been added
              </div>
            </div>
          )}

          {selectedIds.length <= 0 && (
            <div className="ms-3 flex-grow-1">
              <div className="acr-picker__title">Add metrics to display</div>
              <p className="acr-picker__hint mb-0">
                {selectedIds.length === 0
                  ? "Click + to add a metric card"
                  : `${selectedIds.length} metric${selectedIds.length === 1 ? "" : "s"} on dashboard`}
              </p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
